import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import MainPagePanel2 from "./views/components/MainPagePanels/MainPagePanel2";
import MainPagePanel3 from "./views/components/MainPagePanels/MainPagePanel3";
import MainPagePanel4 from "./views/components/MainPagePanels/MainPagePanel4";
// import DavlatDasturi from "./views/DavlatDasturi.vue";
import Rahbariyat from "./views/Rahbariyat.vue";
import RahbariyatTashriflar from "./views/RahbariyatTashriflar.vue";
import SiteMap from "./views/SiteMap.vue";
// import Qonun from "./views/Qonun.vue";
import Kadrlar from "./views/Kadrlar.vue";
import NewsView from "./views/NewsView.vue";
import TaskFunction from "./views/TaskFunction.vue";
import GerbFlag from "./views/GerbFlag.vue";
import FaoliyatOchiqligi from "./views/FaoliyatOchiqligi.vue";
import OchiqMalumot from "./views/OchiqMalumot.vue";
import JamoatchilikKengashi from "./views/JamoatchilikKengashi.vue";
import Muvofiqlashtiruvchi from "./views/Muvofiqlashtiruvchi.vue";
import Hayat from "./views/Hayat.vue";
import Kengash from "./views/Kengash.vue";
import AttestatsiyaKomissiyasi from "./views/AttestatsiyaKomissiyasi.vue";
import Komissiyasi from "./views/Komissiyasi.vue";
import XaridKomissiyasi from "./views/XaridKomissiyasi.vue";
import QonuniylikMustahkamlash from "./views/QonuniylikMustahkamlash.vue";
import VoyagaYetmaganlar from "./views/VoyagaYetmaganlar.vue";
import JinoyatchilikkaQarshi from "./views/JinoyatchilikkaQarshi.vue";
import Murojaatlar from "./views/Murojaatlar.vue";
import Qonunchilik from "./views/Qonunchilik.vue";
import Hujjatlar from "./views/Hujjatlar.vue";
import Yoshlar from "./views/Yoshlar.vue";
import XalqaroNewsView from "./views/XalqaroNewsView";
import YoshlarSiyosati from "./views/YoshlarSiyosati";
import Sudlarda from "./views/Sudlarda.vue";
import Ijtimoiy from "./views/Ijtimoiy.vue";
import News from "./views/News.vue";
import IshonchTel from "./views/IshonchTel.vue";
// import Qidiruvda from "./views/Qidiruvda.vue";
import OzodMuddat from "./views/OzodMuddat.vue";
import Aliment from "./views/Aliment.vue";
import ProkuraturaTizimi from "./views/ProkuraturaTizimi.vue";
import Tuzilma from "./views/Tuzilma.vue";
import Tadbirkorlik from "./views/Tadbirkorlik.vue";
import Contact from "./views/Contact.vue";
import PressService from "./views/PressService";
import GenderEquality from "./views/GenderEquality";
import XalqaroHamkorlik from "./views/XalqaroHamkorlik";
import DavlatDasturi from "./views/DavlatDasturi";
import SavolJavob from "./views/SavolJavob";
import SavolJavobView from "./views/SavolJavobView";
import YoshlarBizning from "./views/YoshlarBizning";
import MurojaatMonitoring from "./views/MurojaatMonitoring";
import SectorNews from "./views/SectorNews";
import Sector from "./views/Sector";
import Sahifa from "./views/Sahifa";
import DavlatMukofot from "./views/DavlatMukofot";
import KorrupsiyagaQarshi from "./views/KorrupsiyagaQarshi";
import Xotinqizlar from "./views/Xotinqizlar";
import IjroIntizomi from "./views/IjroIntizomi";
import Budjet_qonun from "./views/Budjet_qonun";
import KorrupsiyaXabar from "./views/KorrupsiyaXabar";
import ProkurorKlubi from "@/views/ProkurorKlubi.vue";
import Vacancy from "@/views/Vacancy.vue";
import MyApplications from "@/views/MyApplications.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      },
      children:[
        {
          path: "main_page_panel2",
          name: "MainPagePanel2",
          component: MainPagePanel2
        },
        {
          path: "main_page_panel3",
          name: "MainPagePanel3",
          component: MainPagePanel3
        },
        {
          path: "main_page_panel4",
          name: "MainPagePanel4",
          component: MainPagePanel4
        }
      ]
    },
    // {
    //   path: "/davlatdasturi",
    //   name: "davlatdasturi",
    //   components: {
    //     header: AppHeader,
    //     default: DavlatDasturi,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/rahbariyat",
      name: "rahbariyat",
      components: {
        header: AppHeader,
        default: Rahbariyat,
        footer: AppFooter
      }
    },{
      path: "/rahbariyat_tashriflar",
      name: "rahbariyat_tashriflar",
      components: {
        header: AppHeader,
        default: RahbariyatTashriflar,
        footer: AppFooter
      }
    },{
      path: "/sitemap",
      name: "sitemap",
      components: {
        header: AppHeader,
        default: SiteMap,
        footer: AppFooter
      }
    },{
      path: "/tuzilma",
      name: "tuzilma",
      components: {
        header: AppHeader,
        default: Tuzilma,
        footer: AppFooter
      }
    },{
      path: "/murojaat_monitoring",
      name: "murojaat_monitoring",
      components: {
        header: AppHeader,
        default: MurojaatMonitoring,
        footer: AppFooter
      }
    },
    // {
    //   path: "/qonun",
    //   name: "qonun",
    //   components: {
    //     header: AppHeader,
    //     default: Qonun,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/kadrlar",
      name: "kadrlar",
      components: {
        header: AppHeader,
        default: Kadrlar,
        footer: AppFooter
      }
    },{
      path: "/newsview",
      name: "newsview",
      components: {
        header: AppHeader,
        default: NewsView,
        footer: AppFooter
      }
    },{
      path: "/taskfunction",
      name: "taskfunction",
      components: {
        header: AppHeader,
        default: TaskFunction,
        footer: AppFooter
      }
    },{
      path: "/gerbflag",
      name: "gerbflag",
      components: {
        header: AppHeader,
        default: GerbFlag,
        footer: AppFooter
      }
    },{
      path: "/mukofot",
      name: "mukofot",
      components: {
        header: AppHeader,
        default: DavlatMukofot,
        footer: AppFooter
      }
    },{
      path: "/prokuror_klubi",
      name: "prokuror_klubi",
      components: {
        header: AppHeader,
        default: ProkurorKlubi,
        footer: AppFooter
      }
    },{
      path: "/korrupsiyagaqarshi",
      name: "korrupsiyagaqarshi",
      components: {
        header: AppHeader,
        default: KorrupsiyagaQarshi,
        footer: AppFooter
      }
    },{
      path: "/xotinqizlar",
      name: "xotinqizlar",
      components: {
        header: AppHeader,
        default: Xotinqizlar,
        footer: AppFooter
      }
    },{
      path: "/ijro-intizomi",
      name: "ijro-intizomi",
      components: {
        header: AppHeader,
        default: IjroIntizomi,
        footer: AppFooter
      }
    },{
      path: "/faoliyatochiqligi",
      name: "faoliyatochiqligi",
      components: {
        header: AppHeader,
        default: FaoliyatOchiqligi,
        footer: AppFooter
      }
    },{
      path: "/ochiqmalumot",
      name: "ochiqmalumot",
      components: {
        header: AppHeader,
        default: OchiqMalumot,
        footer: AppFooter
      }
    },{
      path: "/budjet_qonun",
      name: "budjet_qonun",
      components: {
        header: AppHeader,
        default: Budjet_qonun,
        footer: AppFooter
      }
    },{
      path: "/jamoatchilikkengashi",
      name: "jamoatchilikkengashi",
      components: {
        header: AppHeader,
        default: JamoatchilikKengashi,
        footer: AppFooter
      }
    },{
      path: "/muvofiqlashtiruvchi",
      name: "muvofiqlashtiruvchi",
      components: {
        header: AppHeader,
        default: Muvofiqlashtiruvchi,
        footer: AppFooter
      }
    },{
      path: "/hayat",
      name: "hayat",
      components: {
        header: AppHeader,
        default: Hayat,
        footer: AppFooter
      }
    },{
      path: "/kengash",
      name: "kengash",
      components: {
        header: AppHeader,
        default: Kengash,
        footer: AppFooter
      }
    },{
      path: "/attestatsiya_komissiyasi",
      name: "attestatsiya_komissiyasi",
      components: {
        header: AppHeader,
        default: AttestatsiyaKomissiyasi,
        footer: AppFooter
      }
    },{
      path: "/komissiyasi",
      name: "komissiyasi",
      components: {
        header: AppHeader,
        default: Komissiyasi,
        footer: AppFooter
      }
    },{
      path: "/xarid_komissiyasi",
      name: "xarid_komissiyasi",
      components: {
        header: AppHeader,
        default: XaridKomissiyasi,
        footer: AppFooter
      }
    },{
      path: "/qonuniylikmustahkamlash",
      name: "qonuniylikmustahkamlash",
      components: {
        header: AppHeader,
        default: QonuniylikMustahkamlash,
        footer: AppFooter
      }
    },{
      path: "/voyagayetmaganlar",
      name: "voyagayetmaganlar",
      components: {
        header: AppHeader,
        default: VoyagaYetmaganlar,
        footer: AppFooter
      }
    },{
      path: "/jinoyatchilikkaqarshi",
      name: "jinoyatchilikkaqarshi",
      components: {
        header: AppHeader,
        default: JinoyatchilikkaQarshi,
        footer: AppFooter
      }
    },{
      path: "/murojaatlar",
      name: "murojaatlar",
      components: {
        header: AppHeader,
        default: Murojaatlar,
        footer: AppFooter
      }
    },{
      path: "/qonunchilik",
      name: "qonunchilik",
      components: {
        header: AppHeader,
        default: Qonunchilik,
        footer: AppFooter
      }
    },{
      path: "/hujjatlar",
      name: "hujjatlar",
      components: {
        header: AppHeader,
        default: Hujjatlar,
        footer: AppFooter
      }
    },{
      path: "/yoshlar",
      name: "yoshlar",
      components: {
        header: AppHeader,
        default: Yoshlar,
        footer: AppFooter
      }
    },{
      path: "/yoshlarsiyosati",
      name: "yoshlarsiyosati",
      components: {
        header: AppHeader,
        default: YoshlarSiyosati,
        footer: AppFooter
      }
    },{
      path: "/sudlarda",
      name: "sudlarda",
      components: {
        header: AppHeader,
        default: Sudlarda,
        footer: AppFooter
      }
    },{
      path: "/ijtimoiy",
      name: "ijtimoiy",
      components: {
        header: AppHeader,
        default: Ijtimoiy,
        footer: AppFooter
      }
    },{
      path: "/news",
      name: "news",
      components: {
        header: AppHeader,
        default: News,
        footer: AppFooter
      }
    },{
      path: "/sector",
      name: "sector",
      components: {
        header: AppHeader,
        default: Sector,
        footer: AppFooter
      }
    },{
      path: "/sahifa",
      name: "sahifa",
      components: {
        header: AppHeader,
        default: Sahifa,
        footer: AppFooter
      }
    },{
      path: "/sectornews",
      name: "sectornews",
      components: {
        header: AppHeader,
        default: SectorNews,
        footer: AppFooter
      }
    },{
      path: "/gender_equality",
      name: "gender_equality",
      components: {
        header: AppHeader,
        default: GenderEquality,
        footer: AppFooter
      }
    },{
      path: "/xalqaro_hamkorlik",
      name: "xalqaro_hamkorlik",
      components: {
        header: AppHeader,
        default: XalqaroHamkorlik,
        footer: AppFooter
      }
    },{
      path: "/davlat_dasturi",
      name: "davlat_dasturi",
      components: {
        header: AppHeader,
        default: DavlatDasturi,
        footer: AppFooter
      }
    },{
      path: "/savol-javob",
      name: "savoljavob",
      components: {
        header: AppHeader,
        default: SavolJavob,
        footer: AppFooter
      }
    },{
      path: "/savol-javob-view/:id",
      name: "savoljavobview",
      components: {
        header: AppHeader,
        default: SavolJavobView,
        footer: AppFooter
      }
    },{
      path: "/yoshlar_bizning",
      name: "yoshlar_bizning",
      components: {
        header: AppHeader,
        default: YoshlarBizning,
        footer: AppFooter
      }
    },{
      path: "/xalqaro_news_view",
      name: "xalqaro_news_view",
      components: {
        header: AppHeader,
        default: XalqaroNewsView,
        footer: AppFooter
      }
    },
    {
      path: "/pressservice",
      name: "pressservice",
      components: {
        header: AppHeader,
        default: PressService,
        footer: AppFooter
      }
    },
      {
      path: "/ishonchtel",
      name: "ishonchtel",
      components: {
        header: AppHeader,
        default: IshonchTel,
        footer: AppFooter
      }
    },{
      path: "/tadbirkorlik",
      name: "tadbirkorlik",
      components: {
        header: AppHeader,
        default: Tadbirkorlik,
        footer: AppFooter
      }
    },{
      path: "/ozodmuddat",
      name: "ozodmuddat",
      components: {
        header: AppHeader,
        default: OzodMuddat,
        footer: AppFooter
      }
    },{
      path: "/aliment",
      name: "aliment",
      components: {
        header: AppHeader,
        default: Aliment,
        footer: AppFooter
      }
    },{
      path: "/prokuraturatizimi",
      name: "prokuraturatizimi",
      components: {
        header: AppHeader,
        default: ProkuraturaTizimi,
        footer: AppFooter
      }
    },
    // {
    //   path: "/qidiruvda",
    //   name: "qidiruvda",
    //   components: {
    //     header: AppHeader,
    //     default: Qidiruvda,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: "/korrupsiyaxabar",
      name: "korrupsiyaxabar",
      components: {
        header: AppHeader,
        default: KorrupsiyaXabar,
        footer: AppFooter
      }
    },
    {
      path: "/vacancy",
      name: "vacancy",
      components: {
        header: AppHeader,
        default: Vacancy,
        footer: AppFooter
      }
    },
    {
      path: "/my-applications",
      name: "my-applications",
      components: {
        header: AppHeader,
        default: MyApplications,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
